/* ============================================================
   RACEFACTORY — APO Option Image Auto-Revert (5s)
   Pagina prodotto default (template `product`).
   - Mantiene thumbnails invariati anche se APO prova a modificarli.
   - Dopo 5s dall'ultima selezione opzione (o dal page load) → main
     image torna agli URL originali (catturati da data-mws-old-* che
     Mageworx APO popola con i src/srcset originali del prodotto).
   ============================================================ */
(function () {
  'use strict';

  var REVERT_MS = 5000;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var gallery    = document.querySelector('.product__images');
    var mainRoot   = document.querySelector('.product-gallery__main');
    var thumbsRoot = document.querySelector('.product-gallery__thumbnails');

    if (!gallery || !mainRoot) return;

    // Snapshot helper: preferisce data-mws-old-* (URL ORIGINALI del prodotto,
    // salvati da APO prima dello swap). Fallback su attr correnti se APO
    // non ha ancora applicato lo swap.
    function snapshotImages(rootEl) {
      var arr = [];
      if (!rootEl) return arr;
      var imgs = rootEl.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        var el = imgs[i];
        arr.push({
          el:      el,
          src:     el.getAttribute('data-mws-old-src')      || el.getAttribute('src'),
          srcset:  el.getAttribute('data-mws-old-srcset')   || el.getAttribute('srcset'),
          dataSrc: el.getAttribute('data-mws-old-data-src') || el.getAttribute('data-src')
        });
      }
      return arr;
    }

    function restoreImages(snapshotArr) {
      for (var i = 0; i < snapshotArr.length; i++) {
        var snap = snapshotArr[i];
        if (snap.src !== null && snap.el.getAttribute('src') !== snap.src) {
          snap.el.setAttribute('src', snap.src);
        }
        if (snap.srcset !== null && snap.el.getAttribute('srcset') !== snap.srcset) {
          snap.el.setAttribute('srcset', snap.srcset);
        }
        if (snap.dataSrc !== null && snap.el.getAttribute('data-src') !== snap.dataSrc) {
          snap.el.setAttribute('data-src', snap.dataSrc);
        }
      }
    }

    var mainSnapshot  = snapshotImages(mainRoot);
    var thumbSnapshot = snapshotImages(thumbsRoot);
    var initialIndex  = getFlickitySelectedIndex();

    var timer = null;

    function scheduleRevert() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(revertMain, REVERT_MS);
    }

    function onApoChange(e) {
      if (!isApoControl(e.target)) return;
      scheduleRevert();
    }
    document.addEventListener('change', onApoChange, true);
    document.addEventListener('click',  onApoChange, true);

    // MutationObserver thumbnails: ripristina istantaneamente se modificate
    if (thumbsRoot && thumbSnapshot.length && typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(function () { restoreImages(thumbSnapshot); });
      obs.observe(thumbsRoot, {
        attributes:      true,
        attributeFilter: ['src', 'srcset', 'data-src'],
        subtree:         true
      });
    }

    function revertMain() {
      restoreImages(mainSnapshot);
      try {
        var $g = window.jQuery && window.jQuery('.product-gallery__main');
        if ($g && $g.length && $g.data('flickity')) {
          $g.flickity('select', initialIndex, false, true);
        }
      } catch (err) {
        // No-op: Flickity non disponibile
      }
      timer = null;
    }

    function isApoControl(el) {
      if (!el || !el.closest) return false;
      return !!el.closest(
        '.mws-options input, .mws-options button, .mws-options label, .mws-options [class*="mw-option"], ' +
        '.mw-apo-container input, .mw-apo-container button, .mw-apo-container label, .mw-apo-container [class*="mw-option"]'
      );
    }

    function getFlickitySelectedIndex() {
      try {
        var $g = window.jQuery && window.jQuery('.product-gallery__main');
        if ($g && $g.length && $g.data('flickity')) {
          return $g.data('flickity').selectedIndex || 0;
        }
      } catch (err) {}
      return 0;
    }

    // Kick off iniziale: se APO ha pre-applicato swap su default-selected
    // option, dopo 5s revert a immagini prodotto originali.
    scheduleRevert();
  }
})();
